import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "select-filter-button__container" }
const _hoisted_2 = { class: "select-filter-button__text" }
const _hoisted_3 = {
  key: 0,
  class: "speech-bubble"
}
const _hoisted_4 = { class: "circle" }
const _hoisted_5 = { class: "filter-modal-container__main-content main-content" }
const _hoisted_6 = { class: "main-content__content-container content-container" }
const _hoisted_7 = { class: "filter-modal-content__header header" }
const _hoisted_8 = { class: "close-button__container" }
const _hoisted_9 = { class: "close-button__text" }
const _hoisted_10 = { class: "filter-modal-content__main-content main-content" }
const _hoisted_11 = { class: "main-content__title" }
const _hoisted_12 = { class: "main-content__filter-item-container" }
const _hoisted_13 = { class: "filter-modal-content__footer footer" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { ref, watch, onMounted, computed } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { FilterContentItem, FilterModalType, isDateRangeFilterType } from './filterModal';
import { useFilterModalStore } from './useFilterModalStore';
import { storeToRefs } from 'pinia';
import { StyleValue } from 'vue';
import MultipleSelectInput from '../SelectInput/MultipleSelectInput.vue';
import DateTimeRangeFilter from './DateTimeRangeFilter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterModalButton',
  props: {
    filterModalType: {},
    selectInputIndex: { default: 0 },
    filterItems: { default: undefined }
  },
  emits: ["apply"],
  setup(__props: any, { emit: __emit }) {

const store = useFilterModalStore();
const { state } = storeToRefs(store);

// props
const props = __props;

// emits
const emits = __emit;

onMounted(() => {
  store.$reset();
  store.setFilterItems(props.filterModalType);
});

// watch
watch(
  () => props.filterItems,
  (newValue) => {
    store.updateFilterItems(newValue);
  }
);

watch(
  () => props.filterModalType,
  (newValue) => {
    store.setFilterItems(newValue);
  }
);

const filterModalContentClass = computed(() => {
  switch (props.filterModalType) {
    case 'customerForecast':
      return 'filter-modal-content--forecast';
    case 'order':
      return 'filter-modal-content--order';
    default:
      return '';
  }
});

const filterModalStyle = computed((): StyleValue => {
  return {
    top: `${coordinateFilterButton.value.y - 16}px`,
    left: `${coordinateFilterButton.value.x - 16}px`,
    maxHeight: `${800 - coordinateFilterButton.value.y - 16}px`,
  };
});

/**
 * フィルター情報の選択数をカウントする
 * @returns 選択数
 */
const filterItemsCount = computed((): number => {
  let count = 0;
  for (const item of state.value.filterItems) {
    if (item.filterType === 'LAST_CHECKED_AT') {
      const hasRange = item.selectedValue[0] !== undefined || item.selectedValue[1] !== undefined;
      const includeNull = item.includeNull ?? false;
      if (hasRange || includeNull) {
        count = count + 1;
      }
      continue;
    }
    if (isDateRangeFilterType(item.filterType)) {
      const hasRange = item.selectedValue.length > 0 && (item.selectedValue[0] || item.selectedValue[1]);
      const includeNull = item.includeNull ?? false;
      if (hasRange || includeNull) {
        count = count + 1;
      }
      continue;
    }
    if (item.selectedValue.length > 0) {
      count = count + item.selectedValue.length;
    }
  }
  return count;
});

//変数
const t = i18n.t;

const coordinateFilterButton = ref({
  x: 0,
  y: 0,
});
const modalState = ref(false);

/**
 * フィルターボタンクリック時の処理
 */
const onClickFilterButton = () => {
  const buttonContent = document.getElementsByClassName('select-filter-button')[0];
  if (!(buttonContent instanceof HTMLElement)) return;
  coordinateFilterButton.value = { x: buttonContent.offsetLeft, y: buttonContent.offsetTop };
  modalState.value = true;
};

/**
 * 適用ボタンクリック時の処理
 */
const onClickApply = () => {
  modalState.value = false;
  emits('apply', store.appliedFilterContent);
};

/**
 * 閉じるボタンクリック時/モーダル外クリック時の処理
 */
const onClickClose = () => {
  modalState.value = false;
};

/**
 * 全設定クリアボタンクリック時の処理
 */
const onClickClear = () => {
  store.resetAllSetting();
  modalState.value = false;
  emits('apply', store.appliedFilterContent);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      id: "select-filter-button",
      class: "select-filter-button",
      onClick: onClickFilterButton
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(filterItemsCount.value > 0 ? _unref(t)('フィルター中') : _unref(t)('フィルター')), 1),
        _createVNode(SvgLoader, {
          class: "select-filter-button__icon",
          name: "arrowDownBlue"
        }),
        (filterItemsCount.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(filterItemsCount.value), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (modalState.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "filter-modal-bg",
            onClick: onClickClose
          }),
          _createElementVNode("div", {
            class: "filter-modal-container",
            style: _normalizeStyle(filterModalStyle.value)
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["filter-modal-content", filterModalContentClass.value])
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "close-button",
                      onClick: onClickClose
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('forecastForReceipt_closeDetailFilter')), 1),
                        _createVNode(SvgLoader, {
                          class: "close-button__icon",
                          name: "arrowUpBlue"
                        })
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "header__reset-all-button",
                      onClick: onClickClear
                    }, _toDisplayString(_unref(t)('forecastForReceipt_clearAllForDetailFilter')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('forecastForReceipt_filterByItem')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).filterItems, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.filterType,
                          class: "main-content__filter-item filter-item"
                        }, [
                          (item.filterType === 'LAST_CHECKED_AT')
                            ? (_openBlock(), _createBlock(DateTimeRangeFilter, {
                                key: 0,
                                "model-value": _unref(state).filterItems[index].selectedValue,
                                "include-null": _unref(state).filterItems[index].includeNull ?? false,
                                label: item.i18nOptions ? _unref(t)(item.label, item.i18nOptions) : _unref(t)(item.label),
                                "onUpdate:modelValue": (value) => (_unref(state).filterItems[index].selectedValue = value),
                                "onUpdate:includeNull": (value) => (_unref(state).filterItems[index].includeNull = value)
                              }, null, 8, ["model-value", "include-null", "label", "onUpdate:modelValue", "onUpdate:includeNull"]))
                            : (_unref(isDateRangeFilterType)(item.filterType))
                              ? (_openBlock(), _createBlock(DateTimeRangeFilter, {
                                  key: 1,
                                  "model-value": _unref(state).filterItems[index].selectedValue,
                                  "include-null": _unref(state).filterItems[index].includeNull ?? false,
                                  label: item.i18nOptions ? _unref(t)(item.label, item.i18nOptions) : _unref(t)(item.label),
                                  "hide-time": "",
                                  "onUpdate:modelValue": (value) => (_unref(state).filterItems[index].selectedValue = value),
                                  "onUpdate:includeNull": (value) => (_unref(state).filterItems[index].includeNull = value)
                                }, null, 8, ["model-value", "include-null", "label", "onUpdate:modelValue", "onUpdate:includeNull"]))
                              : (_openBlock(), _createBlock(MultipleSelectInput, {
                                  key: 2,
                                  class: "filter-item__select-input",
                                  index: _ctx.selectInputIndex + index,
                                  "selected-list": item.selectedValue,
                                  placeholder: _unref(t)('選択してください'),
                                  label: item.i18nOptions ? _unref(t)(item.label, item.i18nOptions) : _unref(t)(item.label),
                                  "filter-type": item.filterType,
                                  "is-open-prop": _unref(state).currentFilterType === item.filterType,
                                  "filter-modal-type": _ctx.filterModalType,
                                  "use-teleport": "",
                                  "onClick:selectInput": () => (_unref(state).currentFilterType = item.filterType),
                                  "onUpdate:modelValue": (e) => (_unref(state).filterItems[index].selectedValue = e)
                                }, null, 8, ["index", "selected-list", "placeholder", "label", "filter-type", "is-open-prop", "filter-modal-type", "onClick:selectInput", "onUpdate:modelValue"]))
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(TextButton, {
                      "button-style": 'btn-primary',
                      size: 'btn-md',
                      "on-click": onClickApply,
                      class: "footer__button footer__button--confirm"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('適用')), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ])
                ], 2)
              ])
            ])
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})